/** OpenAI Ads uses minor currency units; feed prices use major units. */
export const OPENAI_ADS_PIXEL_ID = '7UzKUBhRPtBCyj6jMLW72m';
export function isOpenAiAdsHost(host: string) {
  return ['printen.eu', 'www.printen.eu'].includes(host.toLowerCase().replace(/\.$/, ''));
}
export function openAiClickReference(value: unknown): string | undefined {
  // Opaque identifier: never trim, decode again, hash or otherwise change it.
  return typeof value === 'string' && value.length > 0 && value.length <= 4096 && !/[\u0000-\u0020\u007f]/.test(value) ? value : undefined;
}
export function openAiBrowserReference(value: unknown): string | undefined {
  return typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value) ? value : undefined;
}
export function openAiEventData(value: unknown, currency: unknown, contents?: unknown) {
  const amount = typeof value === 'number' ? Math.round(value * 100) : undefined;
  if (amount !== undefined && (!Number.isSafeInteger(amount) || amount < 0 || currency !== 'EUR')) return null;
  return {
    type: 'contents' as const,
    ...(amount !== undefined ? { amount, currency: 'EUR' } : {}),
    ...(Array.isArray(contents) ? { contents: contents.flatMap((item) => {
      if (!item || typeof item !== 'object' || typeof item.id !== 'string' || !item.id) return [];
      const quantity = Number(item.quantity ?? 1);
      if (!Number.isSafeInteger(quantity) || quantity < 1) return [];
      return [{ id: item.id, content_type: 'product', quantity }];
    }) } : {}),
  };
}
